import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faHybridFuel } from './assets/img/icons/hybrid-fuel.js';

import {
    faFacebook,
    faTwitter
} from '@fortawesome/free-brands-svg-icons';

import {
    faCircle,
    faBolt,
    faPlaneAlt,
    faBus,
    faBusAlt,
    faTrain,
    faSubway,
    faBatteryBolt as fasBatteryBolt,
    faSortUp,
    faTreeAlt,
    faBriefcase,
    faLeaf,
    faArrowDown,
    faArrowSquareRight,
    faAt,
    faFileDownload,
    faCloud,
    faSuitcase,
    faCar,
    faFistRaised,
    faExchangeAlt,
    faHeartbeat,
    faInfoCircle
} from '@fortawesome/pro-solid-svg-icons';

import {
    faLink,
    faWalking,
    faBicycle
} from '@fortawesome/pro-regular-svg-icons';

import {
    faTint,
    faTimes,
    faInfoSquare,
    faBatteryBolt,
    faLongArrowDown,
    faEngineWarning,
    faLongArrowRight,
    faArrowsV,
    faArrowsH
} from '@fortawesome/pro-light-svg-icons';

library.add(
    faHybridFuel,

    faFacebook,
    faTwitter,

    faCircle,
    faBolt,
    faPlaneAlt,
    faBus,
    faBusAlt,
    faTrain,
    faSubway,
    fasBatteryBolt,
    faSortUp,
    faTreeAlt,
    faBriefcase,
    faLeaf,
    faArrowDown,
    faArrowSquareRight,
    faAt,
    faFileDownload,
    faCloud,
    faSuitcase,
    faCar,
    faFistRaised,
    faExchangeAlt,
    faHeartbeat,
    faInfoCircle,

    faLink,
    faWalking,
    faBicycle,

    faTint,
    faTimes,
    faInfoSquare,
    faBatteryBolt,
    faLongArrowDown,
    faEngineWarning,
    faLongArrowRight,
    faArrowsV,
    faArrowsH
);

Vue.component('fa', FontAwesomeIcon);
